import React from 'react';
import { formatCurrency } from '../../utils/formatters';
import * as Icons from 'lucide-react';
import Card from './Card';

interface MetricCardProps {
  label: string | React.ReactNode;
  value: number | string;
  changePercentage?: number;
  icon: keyof typeof Icons;
}

const MetricCard: React.FC<MetricCardProps> = ({
  label,
  value,
  changePercentage,
  icon,
}) => {
  const Icon = Icons[icon];
  const isValueNumber = typeof value === 'number';
  const formattedValue = isValueNumber ? formatCurrency(value as number) : value;
  
  const isPositiveChange = changePercentage && changePercentage > 0;
  const isNegativeChange = changePercentage && changePercentage < 0;
  
  return (
    <Card className="h-full">
      <div className="flex items-start justify-between">
        <div>
          <div className="text-sm font-medium text-gray-500 dark:text-gray-400">{label}</div>
          <p className="mt-2 text-2xl font-semibold text-gray-900 dark:text-white">{formattedValue}</p>
          
          {changePercentage !== undefined && (
            <div className="mt-2 flex items-center">
              <span
                className={`text-sm font-medium ${
                  isPositiveChange ? 'text-emerald-600 dark:text-emerald-400' : 
                  isNegativeChange ? 'text-red-600 dark:text-red-400' : 'text-gray-500 dark:text-gray-400'
                }`}
              >
                {isPositiveChange && '+'}
                {changePercentage}%
              </span>
              <span className="text-sm text-gray-500 dark:text-gray-400 ml-1">vs. mes anterior</span>
            </div>
          )}
        </div>
        
        <div className="p-2 bg-indigo-50 dark:bg-indigo-900/30 rounded-lg">
          <Icon className="h-6 w-6 text-indigo-600 dark:text-indigo-400" />
        </div>
      </div>
    </Card>
  );
};

export default MetricCard;